import { createAssignmentSelectors } from "../createAssignmentWidgetSlice";

const { selectData, selectLoading, selectError } = createAssignmentSelectors("sectionsAssignment");

export const selectProposalSectionsAssignmentData = selectData;
export const selectProposalSectionsAssignmentLoading = selectLoading;
export const selectProposalSectionsAssignmentError = selectError;
